import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { CadastroService } from 'src/app/services/cadastro.service';
import { finalize } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';


@Component({
    selector: 'app-alt-contato',
    templateUrl: './alt-contato.component.html',
    styleUrls: ['./alt-contato.component.css'],
    imports: [ReactiveFormsModule]
})
export class AltContatoComponent implements OnInit {

  loading: boolean = false;
  msgErro: string = null;
  form: FormGroup = null;

  dados: any = null;

  constructor(private cadastro: CadastroService, private toastr: ToastrService) {

  }

  ngOnInit() {
    this.carregarDados();
  }

  setForm(){

    this.form = new FormGroup({
      email: new FormControl(this.dados.DCR_EMAIL, [Validators.required, Validators.email]),
      celular: new FormControl(this.dados.DCR_DDD_CELULAR + this.dados.DCR_CELULAR, [Validators.required, Validators.minLength(11)]),
      assinatura: new FormControl(null, [Validators.required])
    });

  }

  carregarDados(){

    this.loading=true;

    this.cadastro
        .dadosContatoListar()
        .pipe(
          finalize(() => { this.loading=false })
        )
        .subscribe(
          (res: any) => {

            this.dados = res;

            this.setForm();

          },
          (httpError: HttpErrorResponse) => {

          }
        )

  }

  salvar(){

    this.loading = true;

    let celularCompleto: string = this.form.get("celular").value;

    let ddd = celularCompleto.substr(0, 2);
    let celular = celularCompleto.substr(2, celularCompleto.length);


    let dados: any = { 
                      DDICelular: 55, 
                      DDDCelular: ddd, 
                      celular: celular, 
                      email: this.form.get('email').value, 
                      assinatura: this.form.get('assinatura').value 
                    };

    this.cadastro
    .dadosContatoAlterar(dados)
    .pipe(
      finalize(() => { this.loading=false })
    )
    .subscribe(
      (res: boolean) => {

        if(res){
          this.toastr.success("Dados alterados com sucesso");
        }

      },
      (error: HttpErrorResponse) => {

        this.msgErro = error.error.ex;
   
        setTimeout(()=>{
          this.msgErro = null;
        }, 5000);

      }
    )

  }

}
